import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getAuth } from "../redux/reducers/auth";
import { Roles } from "common/RoleFormatter";
import { appUrls } from "../constants/appUrls";

function PublicRoute({ children, isAuth }) {
  const { right: userRight } = useSelector(getAuth);

  if (isAuth && userRight === Roles.TECHNICAL_SPECIALIST) {
    return <Navigate to={appUrls.facebookReg} replace />;
  }

  if (isAuth && userRight === Roles.ROLE_SALE_MANAGER) {
    return <Navigate to={appUrls.preModeration} replace />;
  }

  if (isAuth) {
    return <Navigate to={appUrls.clientList} replace />;
  }

  return window.location.pathname === appUrls.clientList ? (
    <Navigate to={appUrls.login} replace state={{ from: window.location }} />
  ) : (
    children
  );
}

export default PublicRoute;